import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import NavBarMenu from "@/modules/vue/components/NavBarMenu.vue";
import NavBarMenuItem from "@/modules/vue/components/NavBarMenuItem.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencyLayout',
  setup(__props) {
    const route = useRoute();
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, _createSlots({
        title: _withCtx(() => [_renderSlot(_ctx.$slots, "title")]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 2
      }, [_ctx.$config('coins.enabled') ? {
        name: "submenu",
        fn: _withCtx(() => [_createVNode(NavBarMenu, null, {
          default: _withCtx(() => [_createVNode(NavBarMenuItem, {
            to: {
              name: 'action-points.exchange',
              params: _unref(route).params
            },
            icon: _ctx.IconEnum.ArrowsHorizontal,
            label: _ctx.$t('exchange')
          }, null, 8, ["to", "icon", "label"]), _ctx.$config('coins.enabled') ? (_openBlock(), _createBlock(NavBarMenuItem, {
            key: 0,
            to: {
              name: 'action-points.buy-coins',
              params: _unref(route).params
            },
            icon: _ctx.IconEnum.MoneyBillAltRegular,
            label: _ctx.$t('buy_coins')
          }, null, 8, ["to", "icon", "label"])) : _createCommentVNode("", true)]),
          _: 1
        })])
      } : undefined]), 1024);
    };
  }
});